import type { FC } from 'react'

import { Container } from '@skytech/ui/Container'
import { useQuery } from '@tanstack/react-query'
import ChevronRightIcon from 'mdi-react/ChevronRightIcon'
import { Link } from 'react-router-dom'

import { Translation } from '@/app/translations/Translation'
import { useAdminAccess } from '@/hooks/access'
import queries from '@/modules/ecom-policy/queries'
import { ecomPolicyResources } from '@/modules/ecom-policy/resources'
import { APP_ROUTES } from '@/util/app-routes'

import { usePolicyId } from './hooks'
import { PolicyFiltersProvider } from './Policy.context'
import Filters from './products/Filters'
import { Products } from './products/Products'
import Settings from './settings/Settings'
import SettingsSkeleton from './settings/Settings.skeleton'

import './policy.scss'

const Policy: FC = () => {
  useAdminAccess()

  const policyId = usePolicyId()

  const { data: policy, isLoading } = useQuery(queries.policyDetails(policyId), () =>
    ecomPolicyResources.getPolicyDetails(policyId)
  )

  return (
    <Container className="ecom-policy">
      <h4>
        <Link to={APP_ROUTES.HARDWARE_ECOM_POLICY_LIST}>
          <Translation id="Ecom Policy" />
        </Link>{' '}
        <ChevronRightIcon /> #{policyId}
      </h4>

      {isLoading && <SettingsSkeleton />}
      {!isLoading && policy && <Settings policy={policy} />}

      <h3>
        <Translation id="Products" />
      </h3>

      <Filters />

      <Products />
    </Container>
  )
}

export default () => (
  <PolicyFiltersProvider>
    <Policy />
  </PolicyFiltersProvider>
)
